// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

const calculateBulkCost = (n) => {
    if (n <= 10000)
        return n * 0.025;
    if (n <= 1000000)
        return (250 + (n-10000)*0.015);
    return (15100 + (n-1000000)*0.01);
}

export default calculateBulkCost;